/**
 * The `order.*` capabilities (CAPABILITIES.md §3.4): what a person may do to an order as a whole.
 * Its ids and its resource arrived with the cart contract (P0 step 12, decided 2026-10-06); the
 * policies are C1's (P1, P2), each with its parity test against v1's `checkFeature`. Until then
 * the engine has no policy for these ids, so it hides them: it fails closed.
 */
import { definePolicies } from "../engine";

/**
 * An order as a policy sees it (§3.4): a small view of the thing acted on, built by the caller from
 * what it holds, the working sale or a saved order (`orderTaking/cartPanel`'s `orderResource`), so
 * a policy never depends on a page's types. C1 adds a field when a policy first reads one.
 */
export interface OrderResource {
  /** the working sale, being edited; false for a saved order a page only shows */
  editing: boolean;
  /** `saleStatus`, as the server sent it ("Open", "Closed", …); null for a sale never saved */
  status: string | null;
  hasItems: boolean;
  /** `paymentInfo.balanceAmount`; 0 when the bill has not been calculated */
  balanceDue: number;
}

declare module "../types" {
  interface CapabilityMap {
    "order.save": OrderResource;
    "order.hold": OrderResource;
    /** the call centre's Order: places the order Open at the chosen branch (§9.2) */
    "order.place": OrderResource;
    /** discard a new sale, or delete a saved one */
    "order.delete": OrderResource;
    "order.close": OrderResource;
    "order.note": OrderResource;
    /** who the sale is credited to (the waiter) */
    "order.saleBy": OrderResource;
  }
}

export const ORDER_POLICIES = definePolicies("order", []);
